import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
Vue.component('vue-dropzone',vue2Dropzone);

import { VueEditor, Quill } from "vue2-editor";
Vue.component('vue-editor', VueEditor);

import axios from 'axios';
Vue.prototype.$http = axios;

import Clipboard from "v-clipboard";
Vue.use(Clipboard);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
